import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LanguagesComponent } from './languages/languages.component';
import { LogoComponent } from './logo/logo.component';
import { HeaderComponent } from './header.component';
import { TripAdvisorComponent } from './trip-advisor/trip-advisor.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    LanguagesComponent,
    LogoComponent,
    HeaderComponent,
    TripAdvisorComponent
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule { }



// WEBPACK FOOTER //
// ./src/app/header/header.module.ts